import { Position } from "geojson";
import { PointLike } from "mapbox-gl";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";

import { WORKERS_MARKER_OFFSET } from "../map-layers/WorkersLayerV2";
import { GaiaExpandableMapMarkerFieldworker, GaiaExpandableMapMarkerFieldworkerProps } from "./index";

type GaiaMapMarkerFieldworkerOnMapProps = GaiaExpandableMapMarkerFieldworkerProps & {
    coordinates: Position;
    onMouseLeave?: () => void;
    offset?: PointLike;
};

export function GaiaMapMarkerFieldworkerOnMap({
    coordinates,
    onMouseLeave,
    offset = WORKERS_MARKER_OFFSET,
    ...fieldworkerProps
}: GaiaMapMarkerFieldworkerOnMapProps) {
    return (
        <GaiaMapMarker coordinates={coordinates} onMouseLeave={onMouseLeave} offset={offset}>
            <GaiaExpandableMapMarkerFieldworker {...fieldworkerProps} />
        </GaiaMapMarker>
    );
}
